import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../App";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../modal";
import {Outlet, useLocation} from "react-router-dom";
import {Breadcrumb, Card, Descriptions, Divider, Skeleton, Space, Table, Typography} from "antd";
import moment from "moment";
import DB_Remain from "../../../database/document/remain";
import BackButton from "../../tech/back_button";


const EditRemain = () => {

    const {token, setToken} = useContext(Context);
    const {t} = useTranslation();
    const {getRemain} = DB_Remain(token)
    const {errorConnect} = ModalWindow();
    const params = useLocation().state;
    const [wait, setWait] = useState(true);
    const [data, setData] = useState({});
    const [detailsData, setDetailsData] = useState([]);
    const {Text} = Typography;


    const columns = [

        {
            title: "#",
            dataIndex: 'id',
            key: 'id',
        },

        {
            title: t('sku'),
            dataIndex: 'vendor_code',
        },
        {
            title: t('quantity'),
            dataIndex: 'count',
        },
    ]


    useEffect(() => {
        if (params.id != null) {
            getRemain(params.id)
                .then(res => {
                    setData(res.data)
                    setDetailsData(res.data['details'])
                    setWait(false)
                })
                .catch(e => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                });
        }

    }, [])


    return (
        <>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>
                                {t('remains')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton/>

                    </Space>
                </Space>


                <Card>
                    <Skeleton loading={wait} active>
                        <Descriptions>
                            <Descriptions.Item label={t('date')}>
                                <span
                                    style={{fontFamily: 'Montserrat-Medium'}}>{moment(data.date).format("DD.MM.YYYY")}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('warehouse')}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.warehouse}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('branch')}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.branch}</span>
                            </Descriptions.Item>

                        </Descriptions>
                    </Skeleton>
                    <Divider/>

                    <Table
                        style={{'--cursor': "auto" }}
                        columns={columns}
                        dataSource={detailsData}
                        rowKey="id"
                        loading={wait}
                        pagination={false}
                        size={"small"}
                    />

                </Card>


            </div>
            <Outlet/>
        </>
    )
}

export default EditRemain;